import React from 'react';
import Card from 'react-bootstrap/Card';
import { ImPointRight } from 'react-icons/im';

const AboutCard = () => {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: 'justify' }}>
            Hi Everyone, I am <span className="purple">Jordan Lee </span>
            from <span className="purple">United States</span>
            <br />I am a Senior Software Engineer
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Soccer
            </li>
            <li className="about-activity">
              <ImPointRight /> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <h2 style={{ color: 'rgb(155 126 172)' }}>
            "Hi I love to hear interesting and promising business ideas 💯 And I
            use my expertise 🥇 to bring them to life !"{' '}
          </h2>
          <footer className="blockquote-footer">Jordan Lee</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
};

export default AboutCard;
